export default "__VITE_ASSET__J423WnfH__"